import { render, staticRenderFns } from "./modal-criar-agrupamento.vue?vue&type=template&id=1c4e7f8a&scoped=true"
import script from "./modal-criar-agrupamento.vue?vue&type=script&lang=ts"
export * from "./modal-criar-agrupamento.vue?vue&type=script&lang=ts"
import style0 from "./modal-criar-agrupamento.vue?vue&type=style&index=0&id=1c4e7f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e7f8a",
  null
  
)

export default component.exports